<template>
  <v-layout wrap>
    <v-flex xs6 sm2 class="py-2 pl-3">
      ตัวเลือก
    </v-flex>
    <v-flex xs6 sm2>
      <div
        class="text-xs-center"
        style="width: 50px; height: 50px; border: 1px solid white; background: #eee; margin: auto"
      >
        <v-btn fab small flat class="ma-0">
          <v-icon small>camera_alt</v-icon>
        </v-btn>
      </div>
    </v-flex>
    <v-flex xs12 sm8 class="form-control">
      <v-layout>
        <input type="text" class="form-control" v-model="option" />
        <v-btn fab small flat class="ma-1">
          <span class="fas fa-angle-up"></span>
        </v-btn>
        <v-btn fab small flat class="ma-1">
          <span class="fas fa-angle-down"></span>
        </v-btn>
        <v-btn
          fab
          small
          flat
          class="ma-1"
          :disabled="deleteDisabled"
          @click="$emit('deleteOption')"
        >
          <v-icon>delete</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['option', 'deleteDisabled'],
  data() {
    return {
      //   option: this.value
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductStockOption.vue